// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAZQlFkOwUJVJOhitNnipi1KaXr1KKBNMQ",
  authDomain: "taptotrade-auth.firebaseapp.com",
  projectId: "taptotrade-auth",
  storageBucket: "taptotrade-auth.firebasestorage.app",
  messagingSenderId: "809396292300",
  appId: "1:809396292300:web:eb95f1f9f1dd13dd435069"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// Configure Google Provider
provider.setCustomParameters({
  prompt: 'select_account'  // Always prompt for account selection
});

const storage = getStorage(app);

export { auth, provider, storage };
